import { render, staticRenderFns } from "./QuestionsEdit.vue?vue&type=template&id=05fa60e6&scoped=true"
import script from "./QuestionsEdit.vue?vue&type=script&lang=ts"
export * from "./QuestionsEdit.vue?vue&type=script&lang=ts"
import style0 from "./QuestionsEdit.vue?vue&type=style&index=0&id=05fa60e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa60e6",
  null
  
)

export default component.exports